import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'
import * as api from './api'

export default function* root() {
  yield takeLatestApiCall('VENUE_CATEGORIES_FETCH', api.fetchVenueCategories)
}
